export var FeatureFlagValue;
(function (FeatureFlagValue) {
    FeatureFlagValue["Control"] = "Control";
    FeatureFlagValue["A"] = "A";
    FeatureFlagValue["B"] = "B";
    FeatureFlagValue["C"] = "C";
    FeatureFlagValue["D"] = "D";
    FeatureFlagValue["E"] = "E";
    FeatureFlagValue["F"] = "F";
})(FeatureFlagValue || (FeatureFlagValue = {}));
